import FormatGeoJSON from '../node_modules/ol/format/GeoJSON.js';

import bboxClip from '../node_modules/@turf/bbox-clip';

/**
 * Returns a point that is within the map's current view extent and on the feature at "meas"
 * percent along the length of the line. Handles either a LineString or MultiLineString.
 * In the case of a MultiLineString, returns a point on the longest LineString.
 *
 * Useful for placing symbols on LineStrings e.g. highway shields.
 *
 * Uses TurfJs to clip the feature to the extent of the current map view.
 *
 * @param {Feature} feature
 * @param {number between 0 and 1} meas default = 0.5
 *
 * This module accommodates an OpenLayers inconsistency:
 *  getLineStrings() returns an array which may be empty (only available on MultiLineStrings)
 *  getLineString() always returns a new LineString with possibly empty coordinates
 */

export default function(feature, meas = 0.5) {
  const formatGeoJSON = new FormatGeoJSON()

  const clippedFeature = bboxClip(
    formatGeoJSON.writeGeometryObject(feature.getGeometry()), // ol feature converted to geoJSON format
    this.map.getView().calculateExtent()    // current map view extent
  )
  const clippedOlFeature = formatGeoJSON.readGeometry(clippedFeature.geometry) // geoJSON obj converted back to an ol feature
  if (clippedOlFeature.getType() === 'MultiLineString') {
    let lineStrings = clippedOlFeature.getLineStrings()
    if (lineStrings.length) {
      let len
      let previousLength = 0
      let longest
      lineStrings.forEach((e, i) => {
        len = e.getLength()
        if (len > previousLength) {
          previousLength = len
          longest = i
        }
        // console.log(i, e.getLength())
      })
      return lineStrings[longest].getCoordinateAt(meas)
    }
  } else {
    return clippedOlFeature.getCoordinateAt(meas)
  }
}
